import { jsx as n } from "react/jsx-runtime";
import { Skeleton as u } from "@mui/material";
import { contact as s } from "../../queries/contact/index.js";
import { j as c } from "../../index-DVHhaa_b.js";
const D = ({ studentId: r, onClick: a, ...e }) => {
  const { isPending: o, data: i } = new s.studentsForContact().ToQuery();
  if (o)
    return /* @__PURE__ */ n(u, { variant: "circular", width: 40, height: 40 });
  const t = i.find((m) => m.ID === r);
  return t ? /* @__PURE__ */ n(c, { studentId: t.ID, contactFullName: t.DisplaynameSurname, alt: t.DisplaynameSurname, onClick: a, ...e }, t.ID) : null;
};
export {
  D as StudentAvatar
};
//# sourceMappingURL=index.js.map
